import { Colors } from '@zapier/design-system';
export const carouselBlockConfig = {
    name: 'CarouselBlock',
    category: 'Zapier Blocks',
    canHaveChildren: true,
    includeScrollTracking: true,
    image: 'https://cdn.zappy.app/70bef4e8e2b54f2a55972f5c147e48c6.png',
    inputs: [
        {
            name: 'buttonsColor',
            type: 'string',
            enum: [Colors.cream, Colors.earth],
        },
        {
            name: 'iconColor',
            type: 'string',
            enum: ['', ...Object.keys(Colors)],
        },
    ],
};
//# sourceMappingURL=config.js.map